import { useState, useEffect } from 'react';
import useSWR from 'swr';
import { toast } from 'react-toastify';

const DEFAULT_LIMIT = 10;
const EMPTY_EXTRA = {};

/** Paginação admin: altere DEFAULT_LIMIT para mudar todas as telas de cadastro. */
export default function useAdminList(resourceKey, fetchList, extraParams) {
  const extra = extraParams ?? EMPTY_EXTRA;
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');
  const [debouncedQ, setDebouncedQ] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQ(q);
      setPage(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [q]);

  const swrKey = [resourceKey, page, debouncedQ, extra, DEFAULT_LIMIT];

  const { data, error, isLoading, mutate } = useSWR(
    swrKey,
    () =>
      fetchList({
        page,
        limit: DEFAULT_LIMIT,
        q: debouncedQ,
        ...extra,
      }),
    {
      revalidateOnFocus: false,
      onError: err => {
        toast.error(err?.response?.data?.error || 'Erro ao carregar dados!');
      },
    }
  );

  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    limit: data?.limit ?? DEFAULT_LIMIT,
    page,
    setPage,
    q,
    setQ,
    isLoading,
    error,
    mutate,
  };
}
